import { faObjectUngroup } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { IconButton, Tooltip } from "@mui/material";

export const SupersedeAction = (props: { onClick: () => void }) => {
    return (
        <Tooltip title={"Supersede"}>
            <IconButton onClick={() => props.onClick()}>
                <FontAwesomeIcon icon={faObjectUngroup} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );
};
